import config from "config/config";
import useUserContext from "hooks/context-hooks/useUserContext";
import { useQuery } from "react-query";
import { NoteLog } from "types/common";
import { GET } from "utils/restUtils";

export const useFetchPatientNotes = (patientId: string) => {
  const { user } = useUserContext();

  const { data, isLoading, refetch } = useQuery(
    ["patient_notes", patientId],
    async () => {
      if (!patientId) return; // Ensure patientId is present before making the request
      const response = await GET(
        `${config.BASE_URL}/api/v1/notes/${patientId}?api_token=${user?.token}`
      );
      return response.data;
    },
    {
      retry: false,
      enabled: !!patientId, // Only run query if patientId is present
    }
  );

  return [data?.data || ([] as NoteLog[]), isLoading, refetch] as [
    NoteLog[],
    boolean,
    () => void
  ];
};
